import { computeDelay } from '../helpers/delay';
export class TaskError {
    constructor(task, error) {
        this.abortUpload = false;
        this.recoveryTask = null;
        this.task = task;
        this.error = error;
    }
    getTask() {
        return this.task;
    }
    getError() {
        return this.error;
    }
    getPublicError() {
        return this.publicError;
    }
    isInstanceOfOneOfTheseErrors(sdkErrors) {
        return sdkErrors.some(error => this.error instanceof error);
    }
    unrecoverableError(error) {
        this.abortUpload = true;
        this.publicError = error;
        return this;
    }
    shouldAbortUpload() {
        return this.abortUpload;
    }
    setRecoveryTask(recoveryTask, options) {
        this.recoveryTask = recoveryTask;
        this.recoveryTask.delay = computeDelay({
            executionNumber: this.recoveryTask.executionNumber,
            backoffEnabled: options === null || options === void 0 ? void 0 : options.backoffEnabled,
            backoffValue: options === null || options === void 0 ? void 0 : options.backoffValue,
            delay: options === null || options === void 0 ? void 0 : options.delay,
        });
        return this;
    }
    getRecoveryTask() {
        return this.recoveryTask;
    }
}
